import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Offcanvas, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { AppConstant, AvatarConstant } from "../../redux/reducers";
import MButton from "../commons/MButton";
import { MBackspace, MDotActive, MDotEmpty, MDotFill, MDotWrong, MLeftButton } from "../commons/MIcon";
import PasswordSidebarCheckArea from "./PasswordSidebarCheckArea";
import { AvatarAction } from "../../redux/actions/AvatarAction";
import { useNavigate } from "react-router-dom";
import { STATUS } from "../../constants/avatar";

const NumberPanel = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "", label: "" },
  { value: "0", label: "0" },
  { value: -1, label: MBackspace, isComponent: true },
];

const PasswordSidebar = ({ show, AgreeAvatar }) => {
  const { t } = useTranslation();

  const [passwordStrList, setPasswordStrList] = useState((new Array(4)).fill(null));
  const [passwordStep, setPasswordStep] = useState(0);
  const [passwordStepDone, setPasswordStepDone] = useState(false);
  const [confirmCheckList, setConfirmCheckList] = useState(false);
  const [inputStep, setInputStep] = useState(0);

  const [rePasswordStrList, setRePasswordStrList] = useState((new Array(4)).fill(null));
  const [rePasswordStep, setRePasswordStep] = useState(0);
  const [rePasswordStepDone, setRePasswordStepDone] = useState(false);

  const [isSamePassword, setIsSamePassword] = useState(true);
  const [isRequested, setIsRequested] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!show) {
      setPasswordStrList((new Array(4)).fill(null));
      setPasswordStep(0);
      setPasswordStepDone(false);
      setRePasswordStrList((new Array(4)).fill(null));
      setRePasswordStep(0);
      setRePasswordStepDone(false);
      setInputStep(0);
      setConfirmCheckList(false);
      setIsRequested(false);
    }
  }, [show]);

  useEffect(() => {
    if (passwordStepDone && rePasswordStepDone && inputStep === 1) {
      const diffA = JSON.stringify(passwordStrList);
      const diffB = JSON.stringify(rePasswordStrList);
      setIsSamePassword(diffA === diffB);
    } else {
      setIsSamePassword(true);
    }
  }, [passwordStepDone, rePasswordStepDone, inputStep, passwordStrList, rePasswordStrList]);

  useEffect(() => {
    setPasswordStepDone(passwordStrList.every(x => !!x));
  }, [passwordStrList]);

  useEffect(() => {
    setRePasswordStepDone(rePasswordStrList.every(x => !!x));
  }, [rePasswordStrList]);

  const handlerClose = useCallback(() => {
    dispatch({ type: AppConstant.SET_SHOW_PASSWORD, show: false });
  }, [dispatch]);

  const handlerOpenTermsCheck = useCallback(async () => {
    dispatch({ type: AvatarConstant.SET_AVATAR_STATUE, status: STATUS.PROGRESSING })
    setIsRequested(true);
    dispatch({ type: AvatarConstant.SET_TEMP_PASSWORD, value: passwordStrList.join("") });
    const isSuccess = await AgreeAvatar();

    if (isSuccess) {
      // dispatch({ type: AvatarConstant.SET_AVATAR_STATUE, status: STATUS.PROGRESSING })
      // dispatch({ type: AppConstant.SET_SHOW_TEAMS_CHECK, show: false });
      // dispatch({ type: AppConstant.SET_SHOW_PASSWORD, show: false });  
      // await CheckAvatarId(avatarItem._id, avatarItem.region);
    } else {
      dispatch({ type: AvatarConstant.SET_AVATAR_STATUE, status: STATUS.WRONG })
    }
    // dispatch({ type: AppConstant.SET_SHOW_TEAMS_CHECK, show: true });
  }, [AgreeAvatar, dispatch, passwordStrList]);

  const setPassword = useCallback((val) => {
    if (inputStep === 0) {
      if (passwordStrList.every(x => !!x) && val !== -1) {
        return;
      }
      if (val === -1) {
        if (passwordStep > 0) {
          setPasswordStrList(prev => {
            const tmp = [...prev];
            tmp[passwordStep - 1] = null;
            return tmp;
          });
          setPasswordStep(prev => prev - 1);
        }
      } else if (!!val) {
        setPasswordStrList(prev => {
          const tmp = [...prev];
          tmp[passwordStep] = val;
          return tmp;
        });
        setPasswordStep(prev => prev + 1);
      }
    } else if (inputStep === 1) {
      if (rePasswordStrList.every(x => !!x) && val !== -1 && isSamePassword) {
        return;
      }
      let strStep = rePasswordStep;
      if (!isSamePassword) {
        setRePasswordStrList(prev => prev.map(x => null));
        strStep = 0;
      }
      if (val === -1) {
        if (!isSamePassword) {
          setRePasswordStep(0);
        }
        if (strStep > 0) {
          setRePasswordStrList(prev => {
            const tmp = [...prev];
            tmp[strStep - 1] = null;
            return tmp;
          });
          setRePasswordStep(prev => prev - 1);
        }
      } else if (!!val) {
        setRePasswordStrList(prev => {
          const tmp = [...prev];
          tmp[strStep] = val;
          return tmp;
        });
        setRePasswordStep(strStep + 1);
      }
    }
  }, [passwordStep, inputStep, passwordStrList, rePasswordStep, rePasswordStrList, isSamePassword]);

  useEffect(() => {
    if (inputStep === 0 && passwordStepDone) {
      setInputStep(1)
    }
  }, [inputStep, passwordStepDone]);

  useEffect(() => {
    if (inputStep === 1 && rePasswordStep === 4 && passwordStepDone && rePasswordStepDone && !isRequested) {
      const diffA = JSON.stringify(passwordStrList);
      const diffB = JSON.stringify(rePasswordStrList);
      if (diffA === diffB) {
        dispatch({ type: AvatarConstant.SET_PASSWORD, value: passwordStrList.join("") });
        handlerOpenTermsCheck();
      }
    }
  }, [inputStep, rePasswordStep, handlerOpenTermsCheck, isRequested, rePasswordStepDone, passwordStepDone, passwordStrList, rePasswordStrList, dispatch]);

  const callbackNext = useCallback(() => {
    setConfirmCheckList(true);
  }, []);

  return <>
    <Offcanvas
      show={show}
      onHide={handlerClose}
      placement="end"
      className="w-100"
      style={{
        maxWidth: 600,
        borderLeft: "none",
        borderRight: "none",
      }}
    >
      <Offcanvas.Header
        className={`gap-3 ${confirmCheckList ? "bg-primary" : ""}`}
        style={{ boxSizing: "content-box" }}
      >
        <Offcanvas.Title>
          <MLeftButton
            size={40}
            className={`${confirmCheckList ? "text-white" : ""}`}
            onClick={handlerClose}
          />
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="d-flex flex-column user-select-none p-0">
        {!confirmCheckList && <>
          <PasswordSidebarCheckArea callbackNext={callbackNext} />
        </>}
        {confirmCheckList && <>
          <div
            className="d-flex flex-fill flex-column justify-content-center align-items-center bg-primary text-white text-center"
            style={{ maxHeight: 266 }}
          >
            {inputStep === 0 && <>
              <div className="fs-1 fw-bolder px-4">
                {t("Set Password")}
              </div>
              <div className="mt-2 px-2 fs-7" style={{ height: 50 }}>
                {t("Please enter 4 numbers for your password.")}
              </div>
            </>}
            {inputStep === 1 && <>
              <div className="fs-1 fw-bolder px-4">
                {t("Set Password")}
              </div>
              {isSamePassword && <>
                <div className="mt-2 px-2 fs-7" style={{ height: 50 }}>
                  {t("Confirm Password.")}
                </div>
              </>}
              {!isSamePassword && <>
                <div className="mt-2 text-danger-600 px-2 fs-7" style={{ height: 50 }}>
                  {t("Please enter your password again.")}
                </div>
              </>}
            </>}
            <div className="pt-2 pb-5 d-flex align-items-center justify-content-around px-5" style={{ gap: 40 }}>
              {inputStep === 0 && <>
                {passwordStrList.map((x, idx) => <div key={idx}>
                  {idx === passwordStep && <><MDotActive /></>}
                  {idx !== passwordStep && <>
                    {!x && <><MDotEmpty /></>}
                    {x && <><MDotFill /></>}
                  </>}
                </div>)}
              </>}
              {inputStep === 1 && <>
                {rePasswordStrList.map((x, idx) => <div key={idx}>
                  {!isSamePassword && <><MDotWrong /></>}
                  {isSamePassword && <>
                    {idx === rePasswordStep && <><MDotActive /></>}
                    {idx !== rePasswordStep && <>
                      {!x && <><MDotEmpty /></>}
                      {x && <><MDotFill /></>}
                    </>}
                  </>}
                </div>)}
              </>}
            </div>
          </div>
          <Container className="mt-2">
            <Row>
              {NumberPanel.map((x, idx) => <Col
                xs={4}
                key={x.value || `key-${idx}`}
                className="d-flex align-items-center justify-content-center g-4 fw-bolder fs-3 cursor-pointer"
                onClick={() => setPassword(x.value)}
              >
                <div className={x?.isBack && passwordStep === 0 ? "text-gray-300" : ""}>
                  {!x?.isComponent && <>
                    {x.label}
                  </>}
                  {x?.isComponent && <>
                    {React.createElement(x.label, {
                      className: passwordStep === 0 ? "text-gray-400" : "text-black"
                    })}
                  </>}
                </div>
              </Col>)}
            </Row>
          </Container>
          {/* <div className="px-4 pb-4 pt-4">
            {inputStep === 0 && <>
              <MButton
                color={passwordStepDone ? "primary" : "gray-300"}
                circle={true}
                height={56}
                disabled={!passwordStepDone}
                css="w-100 text-white"
                onClick={() => passwordStepDone && setInputStep(1)}
              >
                {t("Next")}
              </MButton>
            </>}
            {inputStep === 1 && <>
              <MButton
                color={(rePasswordStepDone && isSamePassword && !isRequested) ? "primary" : "gray-300"}
                circle={true}
                height={56}
                disabled={!rePasswordStepDone || !isSamePassword || isRequested}
                css="w-100 text-white"
                onClick={() => rePasswordStepDone && isSamePassword && !isRequested && handlerOpenTermsCheck()}
              >
                {!isRequested ? <>
                  {t("Complete Setup")}
                </> : <>
                  {t("Waiting for a response")}
                </>}
                
              </MButton>
            </>}
          </div> */}
        </>}
      </Offcanvas.Body>
    </Offcanvas>
  </>
};

const mapState = (state) => {
  const show = state.AppReducer.show.password;
  return { show };
};

const mapDispatch = dispatch => ({
  AgreeAvatar: () => dispatch(AvatarAction.AgreeAvatar()),
});

export default connect(mapState, mapDispatch)(PasswordSidebar);
